import { mapObjIndexed, nthArg } from 'ramda';

const keyMirror = mapObjIndexed(nthArg(1));

export default keyMirror;
